import { ImagePlus } from "lucide-react";
import { useDropzone } from "react-dropzone";
import { getAssetUrl } from "../lib/api";

export default function ImageDropField({ image, inputTestId, label, onFileUpload, rootTestId }) {
  const { getInputProps, getRootProps, isDragActive } = useDropzone({
    accept: { "image/*": [".jpg", ".jpeg", ".png", ".webp"] },
    maxFiles: 1,
    onDrop: (files) => files[0] && onFileUpload(files[0]),
  });

  return (
    <div {...getRootProps()} className={isDragActive ? "image-drop-field image-drop-active" : "image-drop-field"} data-testid={rootTestId}>
      <input {...getInputProps()} data-testid={inputTestId} />
      {image ? <img src={getAssetUrl(image)} alt={label} /> : <ImagePlus size={22} />}
      <span><ImagePlus size={14} /> {isDragActive ? "Buraya bırakın" : label}</span>
    </div>
  );
}